export const actions = {
  resetValue: '[Meters] RESET_VALUE',
  setActive: '[Meters] SET_ACTIVE'
};

export const resetValue = data => (dispatch) => {
  dispatch({
    type: actions.resetValue,
    payload: data
  });
};

export const setActive = data => (dispatch) => {
  dispatch({
    type: actions.setActive,
    payload: data
  });
};



// WEBPACK FOOTER //
// ./src/actions/meters.js